<template>
	<div class="newsletter-loyalty">
		<div class="df wider-wrapper">
			<div class="nw">
				<BaseCmsLabel code="newsletter_widget_title" class="nw-title" tag="div" />
				<BaseCmsLabel code="newsletter_widget_content" class="nw-subtitle" tag="div" />
				<div class="nw-cnt">
					<BaseNewsletterSignupForm class="nw-form" v-slot="{fields, gdprFields, status, loading}">
						<template v-if="!status?.success">
							<BaseFormField v-for="item in fields" :key="item.name" :item="item" v-slot="{errorMessage}">
								<template v-if="item.type != 'hidden'">
									<BaseFormInput :id="`newsletter-${item.name}`" class="nw-input" :placeholder="labels.get('enter_email')" />
									<span class="nw-error newsletter-error" v-show="errorMessage" v-html="errorMessage" />
								</template>
								<BaseFormInput v-else />
							</BaseFormField>
							<button class="nw-button" type="submit"><UiLoader v-if="loading" /><BaseCmsLabel v-if="!loading" code="newsletter_signup" tag="span" /></button>
							<div class="nw-checkbox" v-if="gdprFields">
								<BaseFormField v-for="field in gdprFields" :key="field.name" :item="field">
									<BaseFormInput v-if="field.type == 'hidden'" />
									<div class="field" v-else v-interpolation>
										<BaseFormInput :id="`nl-${field.name}`" />
										<label :for="`nl-${field.name}`"><span v-html="field.description"></span></label>
									</div>
								</BaseFormField>
							</div>
						</template>
						<BaseCmsLabel v-show="status?.success" tag="div" class="nw-success newsletter_subscribe_success" code="success_subscribe" />
					</BaseNewsletterSignupForm>
				</div>
			</div>


			<div class="loyalty">
				<BaseCmsLabel code="loyalty_intro_title" class="loyalty-intro-title" tag="div" />
				<BaseCmsLabel code="loyalty_intro_subtitle" class="loyalty-intro-subtitle" tag="div" />
				<BaseCmsLabel code="loyalty_intro_buttons" class="loyalty-intro-buttons" tag="div" />
			</div>
		</div>
	</div>
</template>

<script setup>
	const labels = useLabels();
</script>

<style lang="less" scoped>
	.loyalty-intro-buttons{
		display: flex; align-items: center;
		:deep(.btn){flex: 1 1 100%;}
	}
</style>
